<div class="row ss-top-menu">
  <div class="d-flex align-items-center" [ngClass]="selectedTab == 'pre_production' || selectedTab == 'handover_for_production'?'col-md-3':'col-md-4'" >
    <span class="ss-text-light navigation-indicators">Dashboard
      <i class="rightArrow fa fa-angle-right"></i>
    </span>
      <span class="ss-text-dark navigation-indicators fs-13">Tasks</span>
      <span class="ss-text-dark navigation-indicators fs-13" *ngIf="activeTab">
          <i class="rightArrow fa fa-angle-right"></i> {{activeTab}}
    </span>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-2 d-flex align-items-center" *ngIf="role && (role=='admin' || role=='category_head')">
      <button class="rk-interalBtnColor" data-toggle="modal" data-target="#getUserCategorySplit" style="outline: none;">Users by Segment</button>
    </div>

    <div class="justify-content-between  d-flex align-items-center " [ngClass]="selectedTab == 'pre_production' || selectedTab == 'handover_for_production'?'col-md-6':'col-md-5'">
      <label *ngIf="selectedTab == 'pre_production' || selectedTab == 'handover_for_production'" class="w-120px col-bur">{{selectedTab == 'handover_for_production'?'OB Category':'OC Category'}} </label>
      <div class="  select-ngwidth" *ngIf="selectedTab == 'pre_production' || selectedTab == 'handover_for_production'">
        <ng-select class="form-control select_cats" [(ngModel)]="categoryFilter" (change)="searchCategoryProjects(searchparam)" (clear)="categoryFilter =''">
          <ng-option value=""  selected>
           All
           </ng-option>
           <ng-container *ngIf="selectedTab == 'handover_for_production'">

            <ng-option value="ob_asta">
              Asta
             </ng-option>
             <ng-option value="ob_nesta">
              Nesta
             </ng-option>
             <ng-option value="ob_solis">
              Solis
             </ng-option>
             <ng-option value="ob_lux">
              Lux
             </ng-option>

           </ng-container>

           <ng-container *ngIf="selectedTab == 'pre_production'">

            <ng-option value="oc_asta">
              Asta
             </ng-option>
             <ng-option value="oc_nesta">
              Nesta
             </ng-option>
             <ng-option value="oc_solis">
              Solis
             </ng-option>
             <ng-option value="oc_lux">
              Lux
             </ng-option>

           </ng-container>
         
        </ng-select>
        </div>
      <div class="ss-searchbox " [ngClass]="selectedTab == 'pre_production' || selectedTab == 'handover_for_production'?'w-75':'w-100'">
        <i class="fa fa-search"></i>
        <input class="form-control" type="text" 
        placeholder="Type in lead name, id to search..." 
        [(ngModel)]="searchparam">
        </div>
      </div>
      <button  class="btn btn-outline-secondary" (click)="searchCategoryProjects(searchparam)">Search</button>
  </div>

  <p class="text-danger text-bold text-center w-100 pt-5 font20 font-weight-bold">Leads with PM10 from 1st July, 2024 will be fulfilled on Dynamics. POs cannot be raised for these projects.</p>
  <div class="row task-cards justify-content-center" *ngIf="project_count_list">
      <a class="nav-link ss-nav-link card p-3 addCursor" id="handover-for-production" routerLink="." [queryParams]="{tab: 'handover_for_production'}"
      (click)="activateTab('handover_for_production')" [ngClass]="{'active': selectedTab == 'handover_for_production'}">
        <div class="card-header border-bottom-0 p-2 text-center bg-white">
            {{project_count_list["final_boq_count"]}}
        </div>
        <div class="card-footer border-top-0 text-center bg-white p-0">
          Handover/<br>Feasibility
        </div>
      </a> 
      <a class="nav-link ss-nav-link card p-3 addCursor" id="custom-element-approvals-tab" routerLink="." [queryParams]="{tab:'custom_element_approvals'}"
      (click)="activateTab('custom_element_approvals')" [ngClass]="{'active': selectedTab == 'custom_element_approvals'}">
        <div class="card-header border-bottom-0 p-2 text-center bg-white">
            {{project_count_list.custom_elements_count}}
        </div>
        <div class="card-footer border-top-0 text-center bg-white p-0">
          Custom Element Approvals
        </div>
      </a>
      <a class="nav-link ss-nav-link card p-3 addCursor" id="custom-element-approvals-tab" routerLink="." [queryParams]="{tab: 'pre_production'}"
      (click)="activateTab('pre_production')" [ngClass]="{'active': selectedTab == 'pre_production'}">
        <div class="card-header border-bottom-0 p-2 text-center bg-white">
            {{project_count_list["pre_production_count"]}}
        </div>
        <div class="card-footer border-top-0 text-center bg-white p-0">
          Pre Production
        </div>
      </a>
    </div>

  <div class="row" *ngIf="this.selectedTab == 'initial_boqs'">
    <div class="component-parent w-100">
        <initial-boqs></initial-boqs>
    </div>
  </div>

  <div class="row" *ngIf="this.selectedTab == 'cad_approvals'">
    <div class="component-parent w-100">
        <app-cad-approvals></app-cad-approvals>
    </div>
  </div>


  <div class="row" *ngIf="this.selectedTab == 'handover_for_production'">
      <div class="w-100">
          <app-handover-for-production></app-handover-for-production>
        </div>
  </div>
  <div class="row" *ngIf="this.selectedTab == 'custom_element_approvals'">
      <div class="w-100">
          <custom-element-approvals></custom-element-approvals>
        </div>
  </div>
  <div class="row mx-0" *ngIf="this.selectedTab == 'pre_production'">
      <div class="w-100">
          <pre-production [searchparam]="searchparam"></pre-production>
        </div>
  </div>
  
<!-- modal Category role split user list-->
<div class="modal fade" id="getUserCategorySplit" tabindex="-1" role="dialog" aria-labelledby="getUserCategorySplitLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title mt-2" id="getUserCategorySplitLabel">Users by Segment</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>  
      <div class="modal-body">
        <div class="col-md-12 text-center mt-3 mb-5">
          <label class="name">Type<span class="text-danger">:</span></label>
          <select (change) = "getUserCategorySplit($event)" style="outline: none;">
            <option value="" disabled>Select Type</option>
            <option value="category_panel">Category Panel</option>
            <option value="category_non_panel">Category Non Panel</option>
            <option value="category_services">Category Services</option>
          </select>
        </div>
        <div class="row" *ngIf="!this.Vusers">
          <div class="col-12 text-center">
             <!-- <i class="fas fa-spinner fa-spin mt-4" style="font-size: 40px;color:#8C031F"></i> -->
             <p class="mt-4" style="color:#8C031F">Select One Type To Show User List</p>
          </div>
        </div>
        <div class="row mt-4"  *ngIf="this.Vusers && this.Vusers.length > 0">
          <div class="col-md-12">
            <div class="tableDiv">
              <div class="table-responsive">
                <table class="table">
                  <thead class="thead-dark">
                      <tr>
                        <th scope="col" class="firstTh">#</th>
                        <!-- <th scope="col" class="w-25">USER ID</th> -->
                        <th scope="col" class="">USER NAME</th>
                        <th scope="col" class="">EMAIL</th>
                      </tr>
                  </thead>
                  <tbody lass="ss-tbody">
                    <tr *ngFor="let obj of Vusers; let i = index" [attr.data-index]="i">
                      <td style="min-width: 1rem;">{{i+1}}</td>
                      <!-- <td class="capitalize">{{obj.id}}</td> -->
                      <td class="capitalize">{{obj.name}}</td>
                      <td class="capitalize">{{obj.email}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>          
          </div> 
        </div>
      </div>   
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/category/category/tasks/tasks.component.html